<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "Soccer"
    }
</script>

<style scoped>

</style>
